import type { FunctionComponent } from 'react'
import type React from 'react'

import { Formik, FormikProps } from 'formik'

import {
  formFields,
  formFieldsMirvac,
  formValidation,
  formValidationMirvac,
} from 'app/components/Ballot/Disclosures/form.utils'
import {
  BallotsHouseholdIncomeLimit,
  FormBody,
} from 'app/components/Ballot/Disclosures/Formbody'
import { Box } from 'app/components/design-system-components'

type BallotDisclosuresProps = {
  formRef: React.Ref<FormikProps<object>>
  ballotsHouseholdIncomeLimit: BallotsHouseholdIncomeLimit
  ballotsHouseholdIncomeRegion: string
  ballotDisclosuresAnswers: object
  isMirvac: boolean
  teamSlug: string
  ballotHouseholdIncomeYear: string
}

export const BallotDisclosures: FunctionComponent<BallotDisclosuresProps> = ({
  formRef,
  ballotsHouseholdIncomeLimit,
  ballotsHouseholdIncomeRegion,
  ballotDisclosuresAnswers,
  isMirvac = false,
  teamSlug = '',
  ballotHouseholdIncomeYear,
}) => {
  const initialFormValues = isMirvac
    ? {
        [formFieldsMirvac.acceptBallotTermsAndConditions]: false,
        [formFieldsMirvac.householdMeetsIncomeLimits]: false,
        [formFieldsMirvac.victorianResidents]: false,
        [formFieldsMirvac.allLeaseHoldersEmployed]: false,
        [formFieldsMirvac.documentsWithinDays]: false,
      }
    : {
        [formFields.acceptBallotTermsAndConditions]: false,
        [formFields.victorianResidentsOrAustralianCitizens]: false,
        [formFields.householdMeetsIncomeLimits]: false,
        [formFields.noHouseholdMembersOwnProperty]: false,
        [formFields.documentsWithinDays]: false,
        [formFields.householdCanMoveIn]: false,
      }

  const formValidationType = isMirvac ? formValidationMirvac : formValidation
  const baseInitialValues =
    Object.keys(ballotDisclosuresAnswers).length !== 0
      ? ballotDisclosuresAnswers
      : initialFormValues

  return (
    <Box mt={6}>
      <Formik
        initialValues={baseInitialValues}
        onSubmit={() => {}}
        validate={formValidationType}
        innerRef={formRef}
      >
        {() => (
          <FormBody
            ballotsHouseholdIncomeLimit={ballotsHouseholdIncomeLimit}
            ballotsHouseholdIncomeRegion={ballotsHouseholdIncomeRegion}
            ballotHouseholdIncomeYear={ballotHouseholdIncomeYear}
            isMirvac={isMirvac}
            teamSlug={teamSlug}
          />
        )}
      </Formik>
    </Box>
  )
}

export default BallotDisclosures
